<div class="draft-card">
  <div class="draft-content">
    <h3 class="draft-title">{{ draft.name }}</h3>
    <div class="draft-info">
      <span class="completion">{{ draft.progressPercent }}% complete</span>
      <span class="timestamp">{{ draft.lastUpdatedText }}</span>
    </div>
  </div>
  <button
    mat-flat-button
    class="continue-draft-button"
    (click)="handleContinueDraft()"
  >
    Continue
  </button>
</div>
